import React from "react";
import { PanelEditAdSubCategoryType } from "../../../UI/AdSubCategoryTypes/Edit/PanelEditAdSubCategoryType";

const EditAdSubCategoryType = () => {
  return (
    <div>
      <PanelEditAdSubCategoryType />
    </div>
  );
};

export default EditAdSubCategoryType;
